import ApiService from '../_shared/api/apiService';
import localStorage, {
  LOCALSTORAGE_METADATA_VERION
} from '../_shared/constants/localStorage';
import Singleton from '../Singleton';
import renderLocale from '../_shared/helpers/renderLocale';

export default class MediaService extends Singleton<MediaService> {
  /**
   * Returns the Media Manage Metadata
   */
  getMediaManageMetaData = async () => {
    const client = await ApiService();
    const locale = renderLocale();
    let metaDataResponse;

    try {
      const mediaMetadataFromLocal = JSON.parse(
        window.localStorage.getItem(localStorage.MEDIA_METADATA) ?? '{}'
      );

      if (
        mediaMetadataFromLocal &&
        mediaMetadataFromLocal.version ===
          MediaService.getMediaMetadataVersion() &&
        locale === mediaMetadataFromLocal?.locale
      ) {
        return mediaMetadataFromLocal;
      }
      metaDataResponse = await client.apis.media.manageMetadata();

      window.localStorage.setItem(
        localStorage.MEDIA_METADATA,
        JSON.stringify({ ...metaDataResponse?.body, locale })
      );
    } catch (e) {
      // TODO handle exceptions
    }

    return metaDataResponse?.body;
  };

  /**
   * Returns the multimedia for a trade
   */
  static getTradeMultimedia = async (tradeId: number) => {
    const client = await ApiService();
    let tradeMultiMediaResponse;

    try {
      tradeMultiMediaResponse = await client.apis.media.listMedia({
        request: {
          request: {
            tradeId
          }
        }
      });
    } catch (e) {
      // TODO handle exceptions
    }

    return tradeMultiMediaResponse?.body;
  };

  /**
   * Determines which media metadata api version to use
   */
  static getMediaMetadataVersion() {
    return LOCALSTORAGE_METADATA_VERION.TWO;
  }
}
